<template>
  <!-- 客户管理 -->
  <div class="Customer">
    <el-card>
      <el-form :inline="true" :model="searchObj" size="mini">
        <el-form-item label="客户来源">
          <el-select v-model="searchObj.source" placeholder="请选择">
            <el-option label="全部" value="" key="全部"> </el-option>
            <el-option
              v-for="item in sourceList"
              :label="item.source"
              :value="item.source"
              :key="item.source"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="searchObj.timer"
            :clearable="false"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="handelFun('search')"
            >查 询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-upload"
            :loading="loading"
            @click="handelFun('upload')"
            >上传通讯录</el-button
          >
          <el-button
            type="primary"
            @click="handelFun('download')"
            icon="el-icon-download"
            >下载模板</el-button
          >
        </el-form-item>
      </el-form>
      <input
        type="file"
        v-show="false"
        multiple="multiple"
        accept=".xls,.xlsx"
        @change="fileChange"
        ref="FILE"
      />
      <div class="allCheck">
        <el-checkbox
          v-model="allCheck"
          label="选择时间筛选项"
          @change="allCheckFun"
        ></el-checkbox>
        <el-popconfirm
          title="您确定要这样操作吗？"
          @confirm="handelFun('delAll')"
        >
          <el-button type="danger" slot="reference" size="mini"
            >删除选中</el-button
          >
        </el-popconfirm>
      </div>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        style="width: 100%"
        size="mini"
        border
        ref="multipleTable"
        v-loading="loading"
        tooltip-effect="dark"
        @select-all="SelectAll"
        @select="Select"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="客户姓名"> </el-table-column>
        <!-- <el-table-column prop="sex" label="性别"> </el-table-column> -->
        <el-table-column prop="cx" label="意向车型"> </el-table-column>
        <el-table-column prop="tel" label="客户电话"> </el-table-column>
        <el-table-column prop="source" label="客户来源"> </el-table-column>
        <el-table-column prop="trackName" label="跟进人"> </el-table-column>
        <el-table-column label="导入状态">
          <template slot-scope="scope">{{ scope.row.status }}次</template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="导入时间"> </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
      title="导入失败明细"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <el-tag type="success">成功：{{ successCount }}</el-tag
        ><el-tag type="danger">失败：{{ fileCount }}</el-tag>
      </div>
      <el-table :data="uploadFileList" style="width: 100%" border size="mini">
        <el-table-column prop="name" label="客户姓名"> </el-table-column>
        <!-- <el-table-column prop="sex" label="性别"> </el-table-column> -->
        <el-table-column prop="cx" label="意向车型"> </el-table-column>
        <el-table-column prop="source" label="客户来源"> </el-table-column>
        <el-table-column prop="tel" label="客户电话"> </el-table-column>
        <el-table-column prop="trackName" label="跟进人"> </el-table-column>
        <el-table-column prop="fail" label="失败原因"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  formatDate,
  getMonthDays,
  getWeekStartDate,
  getMonthEndDate,
  getMonthStartDate,
  getWeekEndDate
} from "../../utils/Date.js";
export default {
  data() {
    return {
      dialogVisible: false,
      allCheck: false, // 全选
      loading: false,
      searchObj: {
        source: "",
        timer: [
          new Date(new Date().getTime()).Format("YYYY-MM-DD"),
          new Date(new Date().getTime()).Format("YYYY-MM-DD")
        ]
      },
      successCount: 0,
      fileCount: 0,
      uploadFileList: [],
      checkList: [], //选中列表
      checkObj: {},
      tableData: [],
      fileList: [], //文件列表
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      sourceList: [],
      tids: ""
    };
  },
  methods: {
    // 分页
    currentChange(e) {
      this.pagination.pageIndex = e;
      this.getDataList();
    },
    // 弹窗
    handleClose(done) {
      done();
    },
    // 方法集合
    handelFun(type) {
      switch (type) {
        case "search":
          // 查询方法
          this.pagination.pageIndex = 1;
          this.getDataList();
          break;
        case "upload":
          // 上传方法
          this.$refs.FILE.click();
          break;
        case "delAll":
          console.log("删除全部");
          if (this.allCheck) {
            this.delFun(this.tids);
          } else {
            this.delFun(this.checkList.join(","));
          }
          break;
        case "download":
          console.log("下载模板");
          window.open(
            window.location.origin + "/Manage/dist/客户列表导入模板.xlsx"
          );
          break;
        default:
          break;
      }
    },

    // 上传文件
    fileChange(e) {
      if (e.target.files.length != 1) {
        this.$message({
          type: "error",
          message: "请选择一个文件"
        });
        this.$refs.FILE.value = "";
        return;
      } else {
        // if (e.target.files)
        console.log(e.target.files[0]);
        this.fileList = e.target.files;
        // 上传到服务器
        console.log("上传服务器");
        let fromdata = new FormData();
        fromdata.append("file", this.fileList[0]);
        fromdata.append("action", "Uploadtrack");
        this.$axios
          .formatPostData("manage/SetInData.aspx", fromdata)
          .then(res => {
            this.getDataList();
            this.$refs.FILE.value = "";
            let data = res.data;
            if (data.errcode == 0) {
              if (data.fail != 0) {
                this.fileCount = data.fail;
                this.successCount = data.success;
                this.dialogVisible = true;
                this.uploadFileList = data.faillist;
              } else {
                this.$message({
                  message: "导入成功",
                  type: "success"
                });
              }
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },

    // 全部勾选
    allCheckFun(e) {
      this.tableData.forEach(element => {
        this.$refs.multipleTable.toggleRowSelection(element, e);
      });
    },
    // 选择
    Select(e) {
      this.checkObj[this.pagination.pageIndex] = e;
      this.checkList = [];
      for (const key in this.checkObj) {
        this.checkObj[key].forEach(item => {
          this.checkList.push(item.tid);
        });
      }
    },
    // 全选
    SelectAll(e) {
      this.checkObj[this.pagination.pageIndex] = e;
      this.checkList = [];
      for (const key in this.checkObj) {
        this.checkObj[key].forEach(item => {
          this.checkList.push(item.tid);
        });
      }
      console.log(this.checkList);
    },
    // 获取来源
    getSourceList() {
      let fromdata = new FormData();
      fromdata.append("action", "gettracksource");
      this.$axios
        .formatPostData("manage/SetInData.aspx", fromdata)
        .then(res => {
          console.log(res.data);
          if (res.data.errcode == 0) {
            this.sourceList = res.data.list;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //查询跟进列表
    getDataList() {
      this.loading = true;
      let fromdata = new FormData();
      fromdata.append("action", "gettracklist");
      fromdata.append("source", this.searchObj.source);
      fromdata.append("t0", this.searchObj.timer[0]);
      fromdata.append("t1", this.searchObj.timer[1]);
      fromdata.append("pageno", this.pagination.pageIndex);
      fromdata.append("pagesize", this.pagination.pageSize);
      this.$axios
        .formatPostData("manage/SetInData.aspx", fromdata)
        .then(res => {
          this.loading = false;
          console.log(res.data);
          if (res.data.errcode == 0) {
            this.tableData = res.data.list;
            this.pagination.total = res.data.rowCount * 1;
            this.tids = res.data.tids;
            this.$nextTick(() => {
              if (!this.allCheck) {
                this.tableData.forEach(item => {
                  let idx = this.checkList.findIndex(item2 => {
                    return item.tid == item2;
                  });
                  console.log(idx);
                  if (idx != -1) {
                    this.$refs.multipleTable.toggleRowSelection(item, true);
                  }
                });
                return;
              }
              // 全选或者全不选
              this.tableData.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item, true);
              });
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },

    // 删除选择
    delFun(tids) {
      let fromdata = new FormData();
      fromdata.append("action", "deltrack");
      fromdata.append("tids", tids);
      this.$axios
        .formatPostData("manage/SetInData.aspx", fromdata)
        .then(res => {
          console.log(res);
          if (res.data.errcode == 0) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.getDataList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    }
  },
  mounted() {
    this.getSourceList();
    this.getDataList();
  }
};
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}
.allCheck {
  margin: 16px;
}
.allCheck button {
  margin-left: 1rem;
}
</style>
